import Tabs from '@/components/Tabs/Tabs';
export default Tabs;
